import { Button } from '@atoms'
import EmptyState from '@components/molecules/EmptyState'
import useEventsFilteringStore from './stores/useEventsFilteringStore'

import { scopedTranslation } from '@frontend/utils/I18n'

const t = scopedTranslation('shifts_overview.empty_states.events_search')

export default function EventSearchEmptyState() {
  const clearSearchTerm = useEventsFilteringStore((state) => state.clearSearchTerm)

  return (
    <div role="status">
      <EmptyState className="tw:border-0" headline={t('headline')} subtext={t('subtext')} iconType={'search-lg'}>
        <Button size="xl" rank="primary" onClick={clearSearchTerm} ariaLabel={t('button.label')}>
          {t('button.label')}
        </Button>
      </EmptyState>
    </div>
  )
}
